export default __webpack_public_path__ + "static/media/abono.91fefc5a.svg";